import React, { useEffect } from 'react'
import moment from 'moment'
import { FormContextValues } from 'react-hook-form'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'

import GridTextField from '../../components/GridTextField'
import FormPeople from '../../types/FormPeople'
import { applyMaskOnChange, removeMaskIfBackspace } from '../../utils'
import PeopleImg from './PeopleImg'

interface Props {
  form: FormContextValues<FormPeople>
  open: boolean
}

export default function PeopleTabPersonal({ form, open }: Props) {
  useEffect(() => {
    form.register({ name: 'status' })
    form.register({ name: 'gender' })
    form.register({ name: 'maritalStatus' })
    form.register({ name: 'hadMembershipCard' })
  }, [form])

  const status = form.watch('status')
  const gender = form.watch('gender')
  const maritalStatus = form.watch('maritalStatus')
  const hadMembershipCard = form.watch('hadMembershipCard')

  return (
    <Box hidden={!open}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9} container spacing={2}>
          <GridTextField
            label="Nome"
            name="name"
            gridSize={12}
            errorMessage={form.errors?.name?.message}
            inputRef={form.register({
              required: 'Preencha este campo',
            })}
          />
          <GridTextField
            label="Sexo"
            name="gender"
            options={['', 'Masculino', 'Feminino']}
            gridSize={4}
            onChange={(e: any) => form.setValue('gender', e.target.value)}
            value={gender}
          />
          <GridTextField
            label="Estado Civil"
            name="maritalStatus"
            options={[
              '',
              'Solteiro',
              'Casado',
              'União Estável',
              'Divorciado',
              'Viúvo',
            ]}
            gridSize={4}
            onChange={(e: any) =>
              form.setValue('maritalStatus', e.target.value)
            }
            value={maritalStatus}
          />
          <GridTextField
            label="RG"
            name="rg"
            gridSize={4}
            inputRef={form.register}
          />
          <GridTextField
            label="CPF"
            name="cpf"
            gridSize={4}
            inputRef={form.register}
            onKeyDown={removeMaskIfBackspace}
            onChange={applyMaskOnChange('cpf')}
            placeholder="000.000.000-00"
          />
          <GridTextField
            label="Data de nascimento"
            name="birthday"
            gridSize={4}
            inputRef={form.register({
              validate: (value) => {
                return (
                  !value ||
                  moment(value, 'DD/MM/YYYY').isValid() ||
                  'Data inválida'
                )
              },
            })}
            errorMessage={form.errors?.birthday?.message}
            onKeyDown={removeMaskIfBackspace}
            onChange={applyMaskOnChange('date')}
            placeholder="00/00/0000"
          />

          <GridTextField
            label="Telefone"
            name="phone"
            gridSize={4}
            inputRef={form.register}
            onKeyDown={removeMaskIfBackspace}
            onChange={applyMaskOnChange('tel')}
            placeholder="(00) 0000-0000"
          />
          <GridTextField
            label="E-mail"
            name="email"
            gridSize={8}
            inputRef={form.register}
          />
          <GridTextField
            label="Celular"
            name="cellphone"
            gridSize={4}
            inputRef={form.register}
            onKeyDown={removeMaskIfBackspace}
            onChange={applyMaskOnChange('cel')}
            placeholder="(00) 00000-0000"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <PeopleImg form={form} />
        </Grid>
        <GridTextField
          label="Escolaridade"
          name="schooling"
          gridSize={3}
          inputRef={form.register}
        />
        <GridTextField
          label="Profissão"
          name="work"
          gridSize={3}
          inputRef={form.register}
        />
        <GridTextField
          label="Empresa"
          name="company"
          gridSize={3}
          inputRef={form.register}
        />
        <GridTextField
          label="Telefone da empresa"
          name="companyPhone"
          gridSize={3}
          inputRef={form.register}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('tel')}
          placeholder="(00) 0000-0000"
        />
        <GridTextField
          label="Carteira de membro"
          name="hadMembershipCard"
          gridSize={3}
          options={['', 'Sim', 'Não']}
          onChange={(e: any) =>
            form.setValue('hadMembershipCard', e.target.value)
          }
          value={hadMembershipCard}
        />
        <GridTextField
          label="Data da emissão"
          name="membershipCardDate"
          gridSize={3}
          inputRef={form.register}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('date')}
          placeholder="00/00/0000"
        />
        <GridTextField
          label="Status"
          gridSize={3}
          options={['Ativo', 'Inativo', 'Desligado', 'Pendente']}
          value={status}
          onChange={(e: any) => form.setValue('status', e.target.value)}
        />
        <GridTextField
          label="Código interno"
          gridSize={3}
          name="internalCode"
          inputRef={form.register}
        />
        <GridTextField
          label="Observações"
          name="obs"
          gridSize={12}
          inputRef={form.register}
        />
      </Grid>
    </Box>
  )
}
